/**
 * ¿Se puede escribir el perfil de este viajero desde la pantalla de reserva?
 *
 * Asignar departamento o centro de costos en `CostCenterSelect` hace
 * `PUT /api/users/{id}` sobre el perfil de alguien que casi nunca es quien
 * reserva. El backend ya lo defiende —`UpdateUserRequest::authorize()` exige
 * `update-users` sobre la empresa del objetivo, o ser uno mismo— pero disparar
 * el request "a ver si pasa" es peor que no disparar: el interceptor global de
 * axios manda la app a `/error/forbidden` ante un 403 y el usuario pierde la
 * reserva a medias.
 *
 * Vive fuera del componente para poder probarlo: dentro de un `<script setup>`
 * la regla no es alcanzable desde una prueba sin montar media pantalla.
 */
export interface TravelerProfileWriteContext {
	/** Id del usuario autenticado; `undefined` mientras la sesión carga. */
	actorId?: number
	/** Id del viajero cuyo perfil se escribiría. */
	travelerId: number
	/** El actor tiene la ability `update-users` sobre Company. */
	hasUpdateUsers: boolean
}

export const canWriteTravelerProfile = ({
	actorId,
	travelerId,
	hasUpdateUsers,
}: TravelerProfileWriteContext): boolean => {
	// Uno mismo siempre puede: es la única rama que `authorize()` concede sin
	// permiso ni jerarquía.
	if (actorId !== undefined && actorId === travelerId) return true

	return hasUpdateUsers
}
